<app-standard-page>
  <div class="main">
    <p>Nicht gefunden 404</p>
  </div>

  <ng-container *ngIf="auth.authed; else elseBlock">
    <a [routerLink]="'/admin'">Zur Suche</a>
  </ng-container>
  <ng-template #elseBlock>
    <a [routerLink]="'/login'">Login</a>
  </ng-template>

</app-standard-page>

